export default "__VITE_ASSET__ZP9z_TVJ__"